<template>
  <div class="space-y-6">
    <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-lg font-bold text-neutral-900">创值榜</h2>
        <div class="flex gap-3">
          <input
            type="text"
            v-model="searchKeyword"
            @input="handleSearch"
            placeholder="搜索用户..."
            class="px-4 py-2 rounded-lg border border-neutral-300 focus:ring-2 focus:ring-primary focus:border-primary text-sm"
          />
          <button
            @click="exportToExcel"
            class="px-4 py-2 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-colors text-sm font-medium flex items-center"
          >
            <i class="fa fa-file-excel-o mr-2"></i>导出Excel
          </button>
        </div>
      </div>

      <!-- 创值排行榜 -->
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left">
          <thead
            class="bg-neutral-50 text-neutral-500 border-b border-neutral-200"
          >
            <tr>
              <th class="px-4 py-3 font-medium">排名</th>
              <th class="px-4 py-3 font-medium">用户</th>
              <!-- <th class="px-4 py-3 font-medium">发布工具数</th>
              <th class="px-4 py-3 font-medium">获赞数</th> -->
              <th class="px-4 py-3 font-medium text-right">总创值</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-neutral-100">
            <tr
              v-for="(user, index) in filteredList"
              :key="user.id"
              class="hover:bg-neutral-50"
            >
              <td class="px-4 py-3">
                <span
                  class="w-8 h-8 rounded-full flex items-center justify-center font-bold text-white"
                  :class="{
                    'bg-primary': index === 0,
                    'bg-neutral-400': index === 1,
                    'bg-neutral-300': index === 2,
                    'bg-neutral-200 text-neutral-600': index > 2,
                  }"
                >
                  {{ user.rankNum}}
                </span>
              </td>
              <td class="px-4 py-3">
                <div class="flex items-center">
                  <img :src="user.avatar" class="w-10 h-10 rounded-full mr-3" />
                  <span class="font-medium text-neutral-900">{{
                    user.name
                  }}</span>
                </div>
              </td>
              <!-- <td class="px-4 py-3 text-neutral-500">{{ user.toolCount || 0 }}</td>
              <td class="px-4 py-3 text-neutral-500">{{ user.likeCount || 0 }}</td> -->
              <td class="px-4 py-3 text-right font-bold text-primary">
                {{ user.integral }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="flex justify-end mt-4">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="$emit('page-change', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointBoard",
  props: {
    list: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ["page-change", "search"],
  data() {
    return {
      searchKeyword: "",
    };
  },
  computed: {
    filteredList() {
      return this.list.filter((user) => {
        return (
          !this.searchKeyword ||
          user.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        );
      });
    },
  },
  methods: {
    handleSearch() {
      this.$emit("search", this.searchKeyword);
    },
    exportToExcel() {
      // 准备数据
      const data = this.filteredList.map((user, index) => ({
        排名: user.rankNum || index + 1,
        用户名称: user.name,
        总创值: user.integral || 0,
      }));

      if (data.length === 0) {
        alert("没有可导出的数据");
        return;
      }

      // 创建CSV内容
      const headers = Object.keys(data[0]);
      const csvContent = [
        headers.join(","),
        ...data.map((row) => headers.map((h) => `"${row[h]}"`).join(",")),
      ].join("\n");

      // 添加BOM以支持中文
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // 下载文件
      const link = document.createElement("a");
      const date = new Date().format("yyyy-MM-dd");
      link.href = URL.createObjectURL(blob);
      link.download = `创值榜_${date}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>
